<template>
  <section @click.stop="updatepane" :class="{fullscreen:sectionfullscreen}">
    <div class="title" v-if="sectionfullscreen">
      {{ currentmodel }}
    </div>

    <div class="objects" v-if="selectionmode">
      <div @click.stop="toggleselected(object)" class="object" :class="{selected:object.id in selected}" v-for="object in objects">
        {{ object.endpoint }} {{ object.id }}

      </div>

    </div>


    <div v-else class="objects">

      <template v-for="object in objects">
        <div @click.stop="toggleobject(object)" class="object" :class="{fullscreen:object.fullscreen}">
          
          <div>
            {{ object.endpoint }} {{ object.id }}
          </div>
        
          <div class="entries" v-if="object.fullscreen">
            
  
            <div class="subentries">
              <template v-for="entry in object.longentries">
                <template v-if="!['longentries','shortentries'].includes(entry[0])">
                  <div @click.stop="toggleentry(entry,object)" class="entry">
                    {{ entry[0] }}
                  </div>
                </template>
    
              </template>
            </div>
      
            <div class="subentries">
              <template v-for="entry in object.shortentries">
                <template v-if="!['fullscreen'].includes(entry[0])">
                  <div class="entry">
                    {{ entry[0] }}
                    <input :value="entry[1]">
                  </div>
                </template>

              </template>
            </div>
  
          </div>
        
        
            
        </div>
        
  
  
  
      </template>

    </div>

    <button @click.stop="buttonsshowfunction" class="buttonsshow" v-show="sectionfullscreen"> 
      +
    </button>
    <div class="buttons" v-show="buttonsshow">
      <button @click.stop="toggleselection">Selection Mode</button>
      <button @click.stop="show_move_copy">Move/Copy</button>
      <button @click.stop="add">Add</button>



    </div>


  </section>

  <!-- <Pane ref="pane"/> -->
  <Move ref="move"/>


</template>



<script setup>

import {ref,onBeforeUpdate,onUpdated} from 'vue'
// import Pane from '@/components/Pane10.vue'
import Move from '@/components/Move.vue'
import axios from 'axios';

  
  
  
  let objects=ref()
  let sectionfullscreen=ref()
  let currentmodel=ref()
  let pane=ref()
  let move=ref()

  let selected=ref({})


  let buttonsshow=ref(false)
  let selectionmode=ref(false)

  let parents=ref()
  let parent=ref()

  onUpdated(()=>{
    
    if(!active.value){
      return
    }

    objects.value.forEach(object =>{
      let entries=Object.entries(object);
      object.shortentries=[]
      object.longentries=[]
      entries.forEach(entry=>{
        if (typeof entry[1] == 'object'){
          object.longentries.push(entry)
        }else{
          object.shortentries.push(entry)
        }
      })

    })

  })


  function updatepane(){
    if (buttonsshow.value || selectionmode.value || move.value.show){
      buttonsshow.value=false
      selectionmode.value=false
      move.value.show=false

      return
    }




    sectionfullscreen.value=false
    objects.value=[]


  }

  let active=ref(true)
  function toggleobject(object){
    active.value=!active.value
    object.fullscreen=!object.fullscreen

  }

  async function toggleentry(entry,object){
    let model=entry[0]
    let model_ids=entry[1]

    model_ids=model_ids.map(model_id=>{
      if(typeof model_id=='object'){
        console.log('dis object');
        model_id=model_id.id
      }
      return model_id

    })

    console.log(model,model_ids);
    let response=await axios.post(`/database/get_filtered_objects/`,{model:model,ids:model_ids})
    console.log(response);

    pane.value.objects=response.data
    pane.value.currentmodel=model
    pane.value.sectionfullscreen=true
    pane.value.parents=objects.value
    pane.value.parent=object

  }

  function buttonsshowfunction(){
    buttonsshow.value=!buttonsshow.value
  }
  
  function toggleselection(){
    selectionmode.value=!selectionmode.value

  }


  function toggleselected(object){
    console.log(selected.value);
    if (object.id in selected.value){
      delete selected.value[object.id]
      return
    }

    selected.value[object.id]=object
  }

  function show_move_copy(){

    move.value.show=true
    move.value.selectedchildren=selected.value
    move.value.parents=parents.value

  }
  
  async function add(){
    console.log(currentmodel.value,parent.value);
    let response=await axios.post('/database/add/',{model:currentmodel.value,parentmodel:parent.value})
    console.log(response);
  }




  defineExpose({
    objects,
    sectionfullscreen,
    currentmodel,
    parents,
    parent,

  })


</script>



<style scoped>

  section {
    background: var(--primary);
    width: 100vw;
    color: white;
    display: grid;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    grid-template-rows: 1rem auto;
    top: -100vh;
    transition: all 0.2s linear;


  }


  
  .title{
    font-size: x-large;
    color: aliceblue;
    text-align: center;
    text-justify: center;
  }


  .objects {
    background: orange;
    display: grid;
    height: 100%;
    width: inherit;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(auto-fit,minmax(1rem,7rem));
    /* grid-template-rows: repeat(auto-fit,minmax(1rem, 7rem)); */
    

  }


  .object{
    background: var(--primary);
    border: 5px solid black;
    box-shadow: -5px -5px black;
    text-align: center;
    display: grid;
    /* align-items: center; */
    justify-content: center;
    /* align-self: center; */
    /* gap: 2rem; */
    transition: all 0.2s linear;
    grid-template-rows: repeat(auto-fit,1rem);
    width: 5rem;
    height: 5rem;
  }

  .entries{
    background: rgb(136, 66, 66);
    display: grid;
    /* grid-template-rows: repeat(auto-fit,auto); */
    width: inherit;
    height: inherit;
  }

  .subentries{
    display: grid;
    grid-template-columns: repeat(auto-fit,10rem);
    justify-content: center;
    align-items: center;

  }

  .entry{
    background: var(--primary);
    border: 5px solid black;
    box-shadow: -5px -5px black;
    text-align: center;
    transition: all 0.2s linear;
    width: 5rem;
    height: 5rem;


  }


  .fullscreen {
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0; 
    position: absolute;
    
  }

  input{
    width: 100%;
  }

  .buttons{
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .buttonsshow{
    background: var(--options);
    border-radius: 50%;
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    height: 2rem;
    width: 2rem;
  }


  .buttons button{
    border-radius: 1rem;
    height: 3rem;
  }

  .selected{
    background: var(--selected);
  }



</style>